import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 19.5V13C21 11.3431 19.6569 10 18 10H6C4.34315 10 3 11.3431 3 13V19.5M19 10V7.5C19 5.84315 17.6569 4.5 16 4.5H8C6.34315 4.5 5 5.84315 5 7.5V10M4 16.5H20M8.5 9H10.5M13.5 9H15.5",
		stroke: "#324051",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgBed;
